import { navLinks, topicTags } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-100 border-t border-secondary-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-article-line text-lg" />
              </span>
              <span className="font-heading font-black text-foreground-950 text-xl">灵灵黑料</span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-foreground-700">
              一个由社区自发维护的灵灵黑料完整版存档：原帖截图、未删内容与详细经过都留在时间线上，
              只做整理与标注，不替任何人下结论。
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href="#topics"
                aria-label="前往话题墙"
                className="w-9 h-9 rounded-md bg-background-50 border border-secondary-200 text-foreground-700 flex items-center justify-center hover:text-primary-600 hover:border-primary-300 transition-colors"
              >
                <i className="ri-price-tag-3-line" />
              </a>
              <a
                href="#comments"
                aria-label="前往评论区"
                className="w-9 h-9 rounded-md bg-background-50 border border-secondary-200 text-foreground-700 flex items-center justify-center hover:text-primary-600 hover:border-primary-300 transition-colors"
              >
                <i className="ri-chat-3-line" />
              </a>
              <a
                href="#timeline"
                aria-label="前往时间线"
                className="w-9 h-9 rounded-md bg-background-50 border border-secondary-200 text-foreground-700 flex items-center justify-center hover:text-primary-600 hover:border-primary-300 transition-colors"
              >
                <i className="ri-time-line" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading font-bold text-foreground-950 text-sm tracking-wide">站内导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navLinks.map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    className="text-sm font-label text-foreground-700 hover:text-primary-700 transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading font-bold text-foreground-950 text-sm tracking-wide">热门标签</h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {topicTags.slice(0, 8).map((t) => (
                <a
                  key={t.id}
                  href="#topics"
                  className="px-2.5 py-1.5 rounded-md bg-background-50 border border-secondary-200 text-xs font-label text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
                >
                  #{t.label}
                </a>
              ))}
            </div>
            <p className="mt-6 text-xs leading-relaxed text-foreground-600">
              本页内容为社区整理的公开信息存档，如涉及权利问题可通过站内反馈渠道联系处理。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs font-label text-foreground-600">
            © 2026 灵灵黑料 · 完整版档案 · 社区整理
          </p>
          <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="inline-flex items-center gap-1.5 text-xs font-label text-foreground-600 hover:text-primary-700 transition-colors"
          >
            <i className="ri-arrow-up-line" />
            回到顶部
          </button>
        </div>
      </div>
    </footer>
  );
}